import React, { useState } from 'react';
import { addDays, formatDate } from "../../../Utis/GlobalFunctions";
import axios from "axios";
import Swal from 'sweetalert2';
import CircularLoader from "../../../Component/CircularLoader";
import logo from "../../../assets/images/OnlineDonationBanner2.png"
import Select from "../../../Component/Select";

const JTQZakat = () => {
    const [currentDate] = useState(new Date())
    const newDate = addDays(currentDate, 3);
    const [loading,setLoading] = useState(false)
    const [credentials] = useState({
            username: "JTQ_Zakat",
            password: "Live@jz23",
            clientId: "YYEjgeKHPIzBklt",
            clientSecret: "EZEw2NuzM1lw7qq"
    });
    // State to handle form input values
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        amount: '',
        address: '',
        currency: 'PKR',
    });

    // State to handle errors
    const [errors, setErrors] = useState({});


    let payload
    if(formData.currency === "PKR") {
        console.log("Working PKR")
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: formData?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.currency === "PKR" ? formData?.phoneNumber : "",
                CustomerEmail: formData?.email,
                CustomerAddress: formData?.address,
                BillDetail01: [
                    {
                        internationalNumber: formData?.currency !== "PKR" ? formData?.phoneNumber : "",
                    }
                ]
            }
        ];
    }else {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                CurrencyAmount: formData?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.currency === "PKR" ? formData?.phoneNumber : "",
                CustomerEmail: formData?.email,
                CustomerAddress: formData?.address,
                Currency: formData?.currency,
                IsConverted  : "true",
                BillDetail01: [
                    {
                        internationalNumber: formData?.currency !== "PKR" ? formData?.phoneNumber : "",

                    }
                ]
            }
        ];
    }



    const currencyData = [
        { id: 1, name: "PKR", value: "PKR" },
        { id: 2, name: "USD", value: "USD" },
    ];


    // Handle input changes and update form data
    // Handle input changes and update form data with real-time validation
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update the form data state
        setFormData({
            ...formData,
            [name]: value,
        });

        // Validate the specific field on change
        validateField(name, value);
    };

// Real-time field validation
    const validateField = (name, value) => {
        let fieldError = {};

        switch (name) {
            case "name":
                if (!value) {
                    fieldError.name = "Name is required.";
                } else {
                    fieldError.name = ""; // Clear error if input is valid
                }
                break;
            case "email":
                if (!value) {
                    fieldError.email = "Email is required.";
                } else if (!/\S+@\S+\.\S+/.test(value)) {
                    fieldError.email = "Email address is invalid.";
                } else {
                    fieldError.email = ""; // Clear error if input is valid
                }
                break;
            case "phoneNumber":
                if (!value) {
                    fieldError.phoneNumber = "Phone number is required.";
                } else {
                    fieldError.phoneNumber = ""; // Clear error if input is valid
                }
                break;
            case "currency":
                if (!value) {
                    fieldError.currency = "Currency is required.";
                } else {
                    fieldError.currency = ""; // Clear error if input is valid
                }
                break;
            case "amount":
                if (!value) {
                    fieldError.amount = "Amount is required.";
                } else if (formData?.currency === "PKR" && value < 500) {
                    fieldError.amount = "Amount must be at least 500 PKR.";
                } else if (formData?.currency === "USD" && value < 5) {
                    fieldError.amount = "Amount must be at least $5 for USD.";
                } else {
                    fieldError.amount = ""; // Clear error if input is valid
                }
                break;

            default:
                break;
        }

        // Update errors state
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...fieldError,
        }));
    };



    // Validate form inputs
    const validateForm = () => {
        const newErrors = {};

        // Check if the name field is empty
        if (!formData.name) newErrors.name = "Name is required.";

        // Check if the email is empty or not valid
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email address is invalid.";
        }

        // Check if the phone number field is empty
        if (!formData.phoneNumber) newErrors.phoneNumber = "Mobile Number is required.";


        if (!formData.currency) newErrors.currency = "Currency is required.";


        // Check if the amount field is empty
        if (!formData.amount) newErrors.amount = "Amount is required.";

        // Check if the address field is empty
        // if (!formData.address) newErrors.address = "Address is required.";

        setErrors(newErrors);

        // Return whether the form is valid or not
        return Object.keys(newErrors).length === 0;
    };

    const getAuthToken = async (clientId, clientSecret) => {
        const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
            clientid: clientId,
            clientsecret: clientSecret,
        });
        return tokenResponse.data.token;
    };

    const payproCreateOrder = async (e) => {
        e.preventDefault();

        // Validate the form before submission
        const isValid = validateForm();
        if (!isValid) {
            // If the form has errors, prevent submission
            return;
        }

        try {
            setLoading(true);
            const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
            const headers = { 'token': token, 'Content-Type': 'application/json' };
            const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
            const response = await axios.post(url, payload, { headers });

            if(response.data?.data[0].Status === "03") {
                console.log(response.data.data[1].Description)
                await Swal.fire({
                    icon: "error",
                    title: response?.data?.data[1]?.Description,
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
            }else {
                const marketplaceUrl = response.data?.data[1]?.Click2Pay
                await Swal.fire({
                    icon: "success",
                    title: "Redirecting to Marketplace",
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
                window.top.location.href = marketplaceUrl;
            }

            // return response.data;


        } catch (error) {
            console.error('Error creating order:', error);
            setLoading(false)
        }

    }





    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <div className="max-w-xl w-full bg-white shadow-md rounded-lg ">
                <div className="flex flex-col gap-2 text-center mb-6  bg-[#025C49] p-4">
                    <h1 className="text-3xl font-Montserrat font-bold text-white ">
                        Zakat is a right that the poor have upon the rich.
                    </h1>
                    <hr className="w-28 mx-auto"/>
                    <p className="text-xl  font-Montserrat text-white mt-1">
                        "One who pays Zakat, Allah will make their wealth increase" (Sahih Bukhari)
                    </p>
                </div>
                {/* Donation Amount */}
                <div className="mb-6 p-4 " >
                    <label
                        className="block text-sm font-medium text-gray-700 mb-2"
                        htmlFor="amount"
                    >
                        How much would you like to donate today?
                    </label>
                    <p className="text-sm text-gray-500 mb-2">
                        All donations directly impact our organization and help us further
                        our mission.
                    </p>
                    {errors.amount && <p className="text-red-600 text-sm">{errors.amount}</p>}
                    <div className="flex items-center border rounded-md shadow-sm">
                        <SelectNew
                            selectValue={formData?.currency}
                            setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                            name="currency"
                            data={currencyData}
                        />
                        <input
                            id="amount"
                            className="w-full p-1 pr-2 outline-none border-0 text-3xl focus:ring focus:ring-green-500 text-right"
                            type="text"
                            name="amount"
                            placeholder="Enter Amount"
                            value={formData?.amount}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                {/* Donor Info */}
                <div className="mb-4 p-4">
                    <label
                        className="block text-sm font-medium text-gray-700 mb-2"
                        htmlFor="donor-info"
                    >
                        Who's giving today?
                    </label>
                    <p className="text-sm text-gray-500 mb-2">
                        We'll never share this information with anyone.
                    </p>
                    <div className="space-y-3">
                        <div className="flex gap-2">
                            <div className='w-1/2 flex flex-col gap-1 justify-start '>
                            <input
                                type="text"
                                placeholder="Name"
                                name="name"
                                className="w-full p-3 border rounded-md shadow-sm focus:ring focus:ring-green-500 outline-none"
                                value={formData?.name}
                                onChange={handleChange}
                            />
                                {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}

                            </div>
                            <div className='flex flex-col gap-1 w-1/2'>
                            <input
                                type="email"
                                name="email"
                                value={formData?.email}
                                onChange={handleChange}
                                placeholder="Email"
                                className="w-full p-3 border rounded-md shadow-sm focus:ring focus:ring-green-500 outline-none"
                            />
                                {errors.email && <p className="pl-1 text-red-600 text-sm">{errors.email}</p>}


                            </div>
                        </div>
                        <div className="flex gap-2">
                            <div className='w-1/2 flex flex-col gap-1'>
                                <input
                                    type="text"
                                    name="address"
                                    value={formData?.address}
                                    onChange={handleChange}
                                    placeholder="Address"
                                    className="w-full p-3 border rounded-md shadow-sm focus:ring focus:ring-green-500 outline-none"
                                />
                                {errors.address && <p className="text-red-600 text-sm">{errors.address}</p>}

                            </div>
                            <div className='w-1/2 flex flex-col gap-1'>
                        <input
                            type="tel"
                            name="phoneNumber"
                            value={formData?.phoneNumber}
                            onChange={handleChange}
                            placeholder="(03XXXXXXXXX)"
                            className="w-full p-3 border rounded-md shadow-sm focus:ring focus:ring-green-500 outline-none"
                        />
                                {errors.phoneNumber && <p className="text-red-600 text-sm">{errors.phoneNumber}</p>}

                            </div>
                        </div>
                    </div>
                </div>
                {/* Donation Summary */}
                <div className="mb-6 p-4 flex flex-col gap-4">
                    <h2 className="font-semibold text-gray-700 mb-2 p-2">Donation Summary</h2>
                    <div className="w-full flex items-center justify-between border-b-2 p-3">
                        <span>Payment Amount</span>
                        <span>{formData?.currency +" "+ formData?.amount}</span>
                    </div>
                    <div className="w-full flex items-center justify-between border-b-2 p-3">
                        <span>Giving Frequency</span>
                        <span>One time</span>
                    </div>

                    <div className="w-full flex items-center justify-between border-b-2 p-3">
                        <span className="font-bold">Donation Total</span>
                        <span>{formData?.currency +" "+ formData?.amount}</span>
                    </div>


                </div>
                <p className="text-sm text-gray-500 mb-4 text-center">
                    You will be taken away to PayPro's Payment page to complete the
                    donation.
                </p>
                {/* Submit Button */}
                <div className="text-center flex items-center justify-center">
                    <button
                        onClick={payproCreateOrder}
                        className="flex items-center justify-center gap-2 bg-green-700 text-white py-3 px-6 rounded-md shadow-md hover:bg-green-800 transition">
                        Donate Now {loading ? <CircularLoader/> : null}
                    </button>
                </div>
                {/* Payment Icons */}
                {/*<div className="flex justify-center gap-4 mt-4">*/}
                {/*    <img*/}
                {/*        src="/visa-logo.png"*/}
                {/*        alt="Visa"*/}
                {/*        className="h-6 object-contain"*/}
                {/*    />*/}
                {/*    <img*/}
                {/*        src="/mastercard-logo.png"*/}
                {/*        alt="MasterCard"*/}
                {/*        className="h-6 object-contain"*/}
                {/*    />*/}
                {/*    <img*/}
                {/*        src="/cash-logo.png"*/}
                {/*        alt="Cash"*/}
                {/*        className="h-6 object-contain"*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
        </div>
    );
};

export default JTQZakat;





export const SelectNew = ({ data, selectValue, setSelectValue, name }) => {
    return (

            <select
                value={selectValue || ""}  // Use selectValue to show the selected value
                onChange={(e) => setSelectValue(name, e.target.value)}  // Pass the name and value
                className="w-18 h-full shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block  p-3"
            >
                {data?.map((item, index) => (
                    <option key={index} value={item?.value}>
                        {item?.name}
                    </option>
                ))}
            </select>

    );
};




